import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import BoardDetailsPage from "./pages/BoardDetailsPage";
import ProfileStylingPage from "./pages/ProfileStylingPage";
import { Toaster } from "react-hot-toast";
import QuizPage from "./pages/QuizPage";
import QuizPage2 from "./pages/QuizPage2";
import QuizPage3 from "./pages/QuizPage3";
import Orders from "./pages/Orders";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsofUse from "./pages/TermsofUse";
import ErrorPage from "./pages/ErrorPage";
import ProtectedRoute from "./pages/ProtectedRoute";
import AuthProtectedRoute from "./pages/AuthProtectedRoute";
import IsProfileCompleted from "./pages/IsProfileCompleted";
import PaymentSuccess from "./pages/PaymentSuccess";
import ResetPassword from "./pages/ResetPassword";
import ScrollToTop from "./components/ScrollToTop";
import VersionCheck from "./components/VersionCheck";
import { logPageView } from "./utils/analytics";
import QuizIntroPage from "./pages/QuizIntroPage";
import EvenessBlog from "./pages/EvenessBlog";
import EvenessBlogDetail from "./pages/EvenessBlogDetails";
import NewMarketplace from "./pages/NewMarketplace";
import FashionDetailsPage from "./pages/FashionDetailsPage";
import BoardPage from "./pages/BoardPage";
import NewCartPage from "./pages/NewCartPage";
import MarketplaceSearchProductsPage from "./pages/MarketplaceSearchProductsPage";
import CollectionLandingPage from "./pages/CollectionLandingPage";
import CollectionProductsPage from "./pages/CollectionsProductsPage";
import CheckoutPage from "./pages/CheckoutPage";
import ShippingAddressPage from "./pages/ShippingAddressPage";
import EvenessProPage from "./pages/EvenessProPage";
import ShippingPolicy from "./pages/ShippingPolicy";
import ReturnRefundPolicy from "./pages/ReturnRefundPolicy";
import Disclaimer from "./pages/Disclaimer";
import PaymentPolicy from "./pages/PaymentPolicy";
import FraudSpamPolicy from "./pages/FraudSpamPolicy";
import FAQs from "./pages/FAQs";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import OrderInformationPage from "./pages/OrderInformationPage";
import TrackYourOrder from "./pages/TrackYourOrder";
import NewAccountPage from "./pages/NewAccountPage";
import BrandPage from "./pages/BrandPage";
import CategoryPage from "./pages/CategoryPage";
import SignedInRoute from "./components/SignedInRoute";
import { MarketplaceChatProvider } from "./context/MarketplaceChatProvider";
import EftakhariCollectionPage from "./pages/EftakhariCollectionPage";
import AmirCollectionPage from "./pages/AmirCollectionPage";
import EvenessHowItWorksSEOPage from "./pages/EvenessHowItWorksSEOPage";
import EvenessPersonalStylingSEOPage from "./pages/EvenessPersonalStylingSEOPage";
import EvenessAlgorithmSEOPage from "./pages/EvenessAlgorithmSEOPage";

function App() {
  return (
    <Router>
      <MarketplaceChatProvider>
        <UrlCleanupGuard />
        <PageTracker />
        <ScrollToTop />
        {!(
          typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap"
        ) && <VersionCheck />}
        <Toaster
          position="top-center"
          containerStyle={{
            zIndex: 2147483647,
          }}
          toastOptions={{
            duration: 3000,
          }}
        />
        <Routes>
          <Route path="/" element={<NewMarketplace />} />
          <Route path="/blog" element={<EvenessBlog />} />
          <Route path="/blog/:slug" element={<EvenessBlogDetail />} />
          <Route path="/eveness-pro" element={<EvenessProPage />} />
          <Route path="/amir" element={<AmirCollectionPage />} />
          <Route
            path="/reset-password/:uidb64/:token"
            element={<ResetPassword />}
          />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/policies/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/policies/terms-of-service" element={<TermsofUse />} />
          <Route path="/policies/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/policies/return-refund" element={<ReturnRefundPolicy />} />
          <Route path="/policies/payment-policy" element={<PaymentPolicy />} />
          <Route path="/policies/fraud-spam-policy" element={<FraudSpamPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/how-it-works" element={<EvenessHowItWorksSEOPage />} />
          <Route path="/personal-styling" element={<EvenessPersonalStylingSEOPage />} />
          <Route path="/fashion-matching-algorithm" element={<EvenessAlgorithmSEOPage />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/track-your-order" element={<TrackYourOrder />} />
          <Route path="/shop" element={<CollectionLandingPage />} />
          <Route path="/eftakhari-collection" element={<EftakhariCollectionPage />} />          
          <Route path="/marketplace" element={<NewMarketplace />} />
          <Route path="/shop/products" element={<CollectionProductsPage />} />
          <Route path="/product" element={<FashionDetailsPage />} />
          <Route path="/product/:slug" element={<FashionDetailsPage />} />
          <Route path="/brands/:slug" element={<BrandPage />} />
          <Route path="/categories/:slug" element={<CategoryPage />} />
          <Route
            path="/marketplace-search-products"
            element={<MarketplaceSearchProductsPage />}
          />
          <Route path="/cart" element={<NewCartPage />} />
          <Route path="/order-information" element={<OrderInformationPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route element={<SignedInRoute redirectPath="/" />}>
            <Route path="/shipping-address" element={<ShippingAddressPage />} />
            <Route path="/account/orders" element={<Orders />} />
          </Route>
          <Route element={<AuthProtectedRoute />}>
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route path="/quiz" element={<QuizIntroPage />} />
            <Route path="/quiz1" element={<QuizPage />} />
            <Route path="/quiz2" element={<QuizPage2 />} />
            <Route path="/quiz3" element={<QuizPage3 />} />
              <Route path="/board" element={<BoardPage />} />
              <Route path="/board/:boardSlug" element={<BoardDetailsPage />} />
              <Route element={<IsProfileCompleted />}>
              <Route path="/account" element={<NewAccountPage />} />
              <Route path="/account/profile" element={<ProfileStylingPage />} />
            </Route>
          </Route>

        {/* Catch-all route */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </MarketplaceChatProvider>
    </Router>
  );
}

// Simplified PageTracker
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  return null;
}

function UrlCleanupGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.has("v")) return;
    params.delete("v");
    const cleanedSearch = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: cleanedSearch ? `?${cleanedSearch}` : "",
        hash: location.hash,
      },
      { replace: true },
    );
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}

export default App;
